import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowLeftX"><Path d="M10.9983 9.75L15.5 14.2517M15.5017 9.75L11 14.2517M2.5 12L7.75 4.5H21.5V19.5H7.75L2.5 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowLeftX;
